const t = "_list_16cpf_1", c = "_item_16cpf_6", _ = "_text_16cpf_15", s = "_icon_16cpf_18", e = {
  list: t,
  item: c,
  text: _,
  icon: s
};
export {
  e as default,
  s as icon,
  c as item,
  t as list,
  _ as text
};
